export default __webpack_public_path__ + "static/media/DaimlerCS-Demi.49bb5cf8.eot";